import { Card, CardBody, Table, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";
import DefaultButton from "../../../../../components/Buttons/Default";
import CreateExpenseCategoryModal from "../Modals/CreateExpenseCategory";
import { useState } from "react";
import IconButton from "../../../../../components/Buttons/IconButton";
import { IoCreateOutline } from "react-icons/io5";
import { BsTrash3 } from 'react-icons/bs';
import { del } from "../../../../../utils/helpers/api";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import { toast } from "react-toastify";

function ExpenseCategories({ categories, refreshCategories }) {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [categoryToEdit, setCategoryToEdit] = useState(null);


  const deleteCategory = async () => {
    const data = await del(`/accounting/expense-categories/delete/${categoryToDelete}`);
    if(data?.success) {
      refreshCategories();
      setCategoryToDelete(null);
      toast.success(t('accounting.categoryDeleted'));
    }
  }

  return(
    <TabPane tabId="expense-categories">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">
              {t('accounting.expenseCategories')}
            </p>
            <DefaultButton
              color="primary"
              size="sm"
              onClick={() => {
                setCategoryToEdit(null);
                setCreateModalOpen(true);
              }}
            >
              + {t('accounting.newCategory')}
            </DefaultButton>
          </div>

          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{t('common.name')}</th>
                <th>{t('timeline.createdBy')}</th>
                <th>{t('common.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {categories?.map((data, key) => (
                <tr key={key}>
                  <td>{ data.name }</td>
                  <td>{ data.created_by?.firstname + ' ' + data.created_by?.lastname }</td>
                  <td>
                    <div className="d-flex align-items-center gap-2 h-100">
                      <IconButton
                        size="sm" 
                        outline 
                        color="secondary"
                        onClick={() => {
                          setCategoryToEdit(data);
                          setCreateModalOpen(true);
                        }}
                      >
                        <IoCreateOutline />
                      </IconButton>
                      <IconButton
                        size="sm" 
                        outline 
                        color="danger"
                        onClick={() => setCategoryToDelete(data.id)}
                      >
                        <BsTrash3 />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <CreateExpenseCategoryModal 
        isOpen={createModalOpen}
        toggle={() => setCreateModalOpen(!createModalOpen)}
        onSave={() => refreshCategories()}
        categoryToEdit={categoryToEdit}
      />

      <ConfirmationModal
        isOpen={categoryToDelete !== null}
        title={t('accounting.deleteExpenseCategoryTitle')}
        message={t('accounting.deleteExpenseCategoryConfirm')}
        onConfirm={deleteCategory}
        toggle={() => setCategoryToDelete(null)}
      />
    </TabPane>
  );
}

export default ExpenseCategories;